import { createEntityCollectionStore, type PickActions } from '@core/ngrx-legacy';
import type { ThreadSummary } from '@core/tellent-assistant-types';

const idSelector = (thread: Pick<ThreadSummary, 'id'>) => thread.id;

const { selectors, reducer, actions, namespace } = createEntityCollectionStore<ThreadSummary>()(
  'TellentAssistantThreads',
  {
    idSelector,
    customActions: adapter => ({
      removeOnePessimisticSuccess: (state, { data }: { data: Pick<ThreadSummary, 'id'> }) =>
        adapter.removeOne(state, data.id),
    }),
  },
);

const TellentAssistantThreadsActions: PickActions<
  typeof actions,
  'fetchCollection' | 'removeOnePessimistic' | 'updateOnePessimistic'
> = actions;

export {
  selectors as TellentAssistantThreadsSelectors,
  reducer as TellentAssistantThreadsReducer,
  TellentAssistantThreadsActions,
  namespace as TellentAssistantThreadsNamespace,
};
